/**
 * Maps a font's style name onto a CSS `font-style` keyword.
 *
 * Sketch style names describe the whole face - "Medium", "SemiBold", "Bold
 * Italic" - while `font-style` only accepts `italic` and `oblique`. Emitting
 * the raw name produces invalid declarations such as `font-style: medium`;
 * everything that is not a slant is already carried by `font-weight`.
 *
 * Shared with the Components web view's "Copy CSS", which serialises a parsed
 * style rather than a scene element and so cannot use the CSS generator.
 */
export function getCssFontStyle(fontStyle: string | undefined) {
  const normalized = fontStyle?.toLowerCase()

  if (!normalized) return undefined
  if (normalized.includes('oblique')) return 'oblique'
  if (normalized.includes('italic')) return 'italic'

  return undefined
}
